import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";
export const renderFavoritesIcon = (isInFavorites, favoritesHandler, componentPrefix) => {
    const classNames = isInFavorites ? "i-o-fav-selected" : "";
    return (React.createElement("div", { className: `rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__fav`, "data-uat": `div-ev-list-${componentPrefix}-fav` },
        React.createElement(EventCardIcon, { className: `rj-ev-list__${componentPrefix}-icon--fav`, onClick: favoritesHandler },
            React.createElement(Icon, { i: `i-o-fav i-o-fav-row i-12 ${classNames}` }))));
};
//# sourceMappingURL=renderFavoritesIcon.js.map